/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOtherOpexDto } from '../../models/backend-other-opex-dto';

export interface OpexesOtheropexList$Params {
  /**
   * id Варианта
   */
  variant?: number;
}

export function opexesOtheropexList(
  http: HttpClient,
  rootUrl: string,
  params?: OpexesOtheropexList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendOtherOpexDto>>> {
  const rb = new RequestBuilder(rootUrl, opexesOtheropexList.PATH, 'get');
  if (params) {
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendOtherOpexDto>>;
    }),
  );
}

opexesOtheropexList.PATH = '/api/opexes/otheropex/';
